import { Button } from "primereact/button";
import { Chart } from "primereact/chart";

const DoughnutChart = ({
  data,
  options,
  id = "DoughnutChart",
  canDownload = false,
}) => {
  return (
    <div
      className="flex justify-content-center align-items-center"
      style={{ position: "relative" }}
    >
      {(canDownload && (
        <Button
          icon="pi pi-download"
          text
          rounded
          size="small"
          onClick={() => {
            const canvas = document.querySelector(`#${id} canvas`);
            const image = canvas.toDataURL("image/png", 1.0);
            const link = document.createElement("a");
            link.download = `${id}.png`;
            link.href = image;
            link.click();
          }}
          style={{
            position: "absolute",
            top: "-5px",
            right: "-5px",
            zIndex: 2,
          }}
        />
      )) ||
        null}
      <Chart
        id={id}
        className="w-full flex justify-content-center align-items-center"
        style={{ height: "230px" }}
        type="doughnut"
        data={data}
        options={{
          with: "100%",
          cutout: "75%",
          plugins: {
            legend: {
              position: "bottom", // Change legend position here
            },
          },
          ...options,
        }}
      />
    </div>
  );
};

export default DoughnutChart;
